import { Box } from '@theme-ui/components';
import Cookies from 'js-cookie';

import { COUNTRY_COOKIE } from '@app/helpers/localization';

import { isJPHardware } from '../../helpers';
import type {
  PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as Variant,
  PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants_attributes as VariantAttributes,
} from '../../hook/__generated__/PricingPageShopProduct';
import useFreeShipping from '../../hook/useFreeShipping';
import Price from '../Price';
import StockMessage, { PACKAGE_TYPE } from '../StockMessage';
import { StockIndicatorWrapper } from './styles';

const getAttribute = (
  key: string,
  attributes: Array<VariantAttributes | null>,
): VariantAttributes['adminLabel'] => {
  const target = attributes.find((attribute) => attribute?.code === key);

  return target?.adminLabel ?? null;
};

export interface ProductVariantProps {
  variant: Variant;
  hidePrice?: boolean;
}

const ProductVariantInfo = ({
  variant,
  hidePrice = false,
}: ProductVariantProps) => {
  const { priceRange, stockStatus, releaseDate } = variant.product ?? {};
  const packageType = getAttribute('package_type', variant.attributes ?? []);
  const countryCode = Cookies.get(COUNTRY_COOKIE);
  const { isFreeShipping } = useFreeShipping(countryCode);

  return (
    <Box data-testid="product-variant-info">
      {!hidePrice && <Price price={priceRange} />}

      {/* Stock of JP products is handled by MediaIntegration */}
      {!isJPHardware(variant?.product) && (
        <StockIndicatorWrapper data-testid="product-variant-info-message">
          <StockMessage
            packageType={packageType && PACKAGE_TYPE[packageType]}
            stockStatus={stockStatus}
            releaseDate={releaseDate}
            freeShipping={isFreeShipping}
          />
        </StockIndicatorWrapper>
      )}
    </Box>
  );
};

export default ProductVariantInfo;
